module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Voucher")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kode Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/voucher/form')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Voucher")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Kode Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Filter By Channel")]), _vm._v(" "), _vm._l((_vm.listChannel), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('model-select', {
    attrs: {
      "options": _vm.productList,
      "placeholder": "Filter By Product"
    },
    model: {
      value: (_vm.productSelected),
      callback: function($$v) {
        _vm.productSelected = $$v
      },
      expression: "productSelected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortSelected),
      expression: "sortSelected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Sort By Inventori")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])]), _vm._v(" "), (_vm.channelSelected || _vm.productSelected || _vm.sortSelected) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Clear Filter")])]) : _vm._e()])]), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "has-soldout-warning": true,
      "items": _vm.voucherList,
      "has-action": true,
      "has-add-quota": true,
      "has-search-power": false,
      "has-delete": false,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.currentPage,
      "custom-pagination-per-page": _vm.paging.limit,
      "custom-pagination-total-pages": _vm.paging.total_page,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "addQuota": function($event) {
        return _vm.addQuota($event)
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.paging.total_page) + " ")])]), _vm._v(" "), (_vm.paging.total_page > 1) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(-1)
      }
    }
  }, [_vm._v("\n                          Previous\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "readonly": "",
      "max": _vm.paging.total_page
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == _vm.paging.total_page
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("\n                          Next\n                        ")])]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama Channel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.voucherSelected.data[0]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama Product")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', {
    staticStyle: {
      "word-break": "break-all !important"
    }
  }, [_vm._v(_vm._s(_vm.voucherSelected.data[1]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("Tambah Kuota (Kuota Saat ini: " + _vm._s(_vm.voucherSelected.data[2]) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quota),
      expression: "quota"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "100px",
      "margin-top": "10px"
    },
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.quota)
    },
    on: {
      "click": function($event) {
        _vm.quota = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quota = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeQuota()
      }
    }
  }, [_vm._v("Tambah Kuota")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$('#myModal').modal('hide')
      }
    }
  }, [_vm._v("Batal")])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("Tambah Kuota")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13699534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/voucher/Voucher.vue
// module id = 1284
// module chunks = 0